import { useCallback } from "react";

import { Button } from "@/components/Buttons/index";
import { useChatEventGAPush } from "@/hooks";
import styles from "@/styles/Video.module.scss";

export default function ChatSelect({
  setChatDisplay,
  setIsChatSelected,
  play,
  isLive, // ライブか
  isStartOver, // 追っかけありか
  state,
}) {
  const handleStart = useCallback(() => {
    if (!play) return;
    if (isLive) {
      if (!isStartOver) {
        state.updateResumePoint(-1);
      } else {
        state.updateResumePoint(0.1);
      }
    } else state.updateResumePoint(0);
  }, [play, isLive, isStartOver, state]);

  const { joinRoomEvent } = useChatEventGAPush();

  return (
    <div className={styles.resume}>
      <div className={styles.buttons}>
        <Button
          fillMainColor
          chatSelect
          fontBold
          onClick={() => {
            setChatDisplay(false);
            setIsChatSelected(true);
            handleStart();
          }}
        >
          ▶︎再生する
        </Button>
        <Button
          fillWhiteColor
          chatSelect
          fontBold
          onClick={() => {
            setChatDisplay(true);
            setIsChatSelected(true);
            handleStart();
            joinRoomEvent(state?.rooms?.[0]?.roomId);
          }}
        >
          ▶︎チャット付きで再生する
        </Button>
      </div>
    </div>
  );
}
